import * as React from 'react';

import configureStore from './store';

import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import Routes from './routes';
import i18n from './lib/i18n';
import fontLoader from './lib/load_fonts';

const WebFont = require('webfontloader');

import './styles/app.styl';
import loadConfig from './lib/config';

const store = configureStore({
  config: loadConfig(),
});

const App: React.FunctionComponent = () => {
  i18n.init();

  WebFont.load({
    google: {
      families: ['Noto Sans KR'],
    },
  });

  fontLoader.load(['Noto Sans KR']);

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n.instance}>
        <Routes />
      </I18nextProvider>
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/app.tsx